<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 6c.3183 0 .6235.12643.8485.35147.2251.22505.3515.53027.3515.84853v3.6h3.6c.3183 0 .6235.1264.8485.3515.2251.225.3515.5302.3515.8485s-.1264.6235-.3515.8485c-.225.2251-.5302.3515-.8485.3515h-3.6v3.6c0 .3183-.1264.6235-.3515.8485-.225.2251-.5302.3515-.8485.3515s-.6235-.1264-.8485-.3515c-.2251-.225-.3515-.5302-.3515-.8485v-3.6H7.2c-.31826 0-.62348-.1264-.84853-.3515C6.12643 12.6235 6 12.3183 6 12s.12643-.6235.35147-.8485c.22505-.2251.53027-.3515.84853-.3515h3.6V7.2c0-.31826.1264-.62348.3515-.84853C11.3765 6.12643 11.6817 6 12 6Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 5c.5523 0 1 .44772 1 1v5h5c.5523 0 1 .4477 1 1s-.4477 1-1 1h-5v5c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5H6c-.55228 0-1-.4477-1-1s.44772-1 1-1h5V6c0-.55228.4477-1 1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
